import { bannerFor } from "@/lib/api-error-message"

/*
   The page-level banner for a failed roster fetch, split out of the page. It is separate
   from the table's own empty/error state: this one means the page could not load its
   reference data at all, not that the engagement list came back empty.
*/
export interface ClientsLoadErrorProps {
  error: unknown
}

export function ClientsLoadError({ error }: ClientsLoadErrorProps): JSX.Element {
  const banner = bannerFor(error, "engagements")
  return (
    <div
      role="alert"
      className="rounded-md border border-people/30 bg-people-tint/40 px-4 py-3 text-body-sm text-people"
    >
      <div className="font-medium">{banner.title}</div>
      <div className="mt-0.5">{banner.body}</div>
    </div>
  )
}
